/** A generic function with empty body. */
const noop = () => {
  // this is a noop
};

export default noop;
